import { MasterRequests } from './../../../../core/models/master-requests';
import { ToastService } from 'src/app/core/toast.service';
import { AddMasterRequestsService } from './../../../../core/services/add-master-requests.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface RequestData{
  sass_table_name: string;
  sass_column_name: string;
  sass_other_column_name: string;
  sass_requested_from_table_name: string;
  request_description: string;
  name: string;
  payload?: any;
}
@Component({
  selector: 'app-add-master-requests',
  templateUrl: './add-master-requests.component.html',
  styleUrls: ['./add-master-requests.component.scss']
})
export class AddMasterRequestsComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */

  masterRequestsForm = this._fb.group ({
    name: [null, [Validators.required]],
    status: ['PENDING', [Validators.required]],
    sass_table_name: [null, [Validators.required]],
    sass_column_name: [null, [Validators.required]],
    sass_other_column_name: [null,[Validators.required]],
    sass_requested_from_table_name: [null , [Validators.required]],
    payload: [null]
  });

/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private _dialogRef: MatDialogRef<AddMasterRequestsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RequestData,
    private _fb: FormBuilder,
    private addMasterRequestsService : AddMasterRequestsService,
    private toast: ToastService
  ) { }

/* ---------------------------- Life Cycle hooks ---------------------------- */

  ngOnInit(): void {
    console.log(this.data);
    this.sass_table_name.setValue(this.data.sass_table_name);
    this.sass_column_name.setValue(this.data.sass_column_name);
    this.sass_other_column_name.setValue(this.data.sass_other_column_name);
    this.sass_requested_from_table_name.setValue(this.data.sass_requested_from_table_name)
    this.name.setValue(this.data.name);
    if(this.data.payload){
      this.payload.setValue(this.data.payload);
    }
  }
  dialogClose(master_requests?: any) {
    this._dialogRef.close(master_requests);
  }

/* --------------------------------- Getters -------------------------------- */
  get name () {
    return this.masterRequestsForm.get('name');
  }

  get status() {
    return this.masterRequestsForm.get('status');
  }

  get sass_table_name() {
    return this.masterRequestsForm.get('sass_table_name');
  }
  get sass_column_name() {
    return this.masterRequestsForm.get('sass_column_name');
  }
  get sass_other_column_name() {
    return this.masterRequestsForm.get('sass_other_column_name')
  }

  get sass_requested_from_table_name(){
    return this.masterRequestsForm.get('sass_requested_from_table_name')
  }

  get payload(){
    return this.masterRequestsForm.get('payload')
  }

/* --------------------------- Add Master Requests -------------------------- */

async addMasterRequests(){
    if(this.masterRequestsForm.invalid){
      return;
    }
    const masterRequests = this.masterRequestsForm.value as MasterRequests;
    try {
      const master_request_id: string = await this.addMasterRequestsService.addMasterRequests(masterRequests);
      console.log(master_request_id);
      this.dialogClose({...masterRequests, master_request_id});
      this.toast.openSnackBar('Request raised successfully');
    } catch(error){
      this.toast.openSnackBar('Unable to raise request')
    }
  }
}

